var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded == false)?_c('waiting'):_vm._e(),(_vm.loaded)?_c('BannerList',{attrs:{"listIcon":"mdi-view-carousel","listTitle":"배너 관리","items":_vm.items},on:{"registItem":_vm.registItem,"modifyItem":_vm.modifyItem,"deleteItem":_vm.deleteItem}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }